<template>
  <mw-dialog ref="dialog" size="small_mini" :title="title" :appendToBody="false" :footerButton="footerButton"  customClass="mw-flow-complete"  :beforeClose="beforeClose">
    <mw-table :api="api" :columns="columns" :pagination="false" ref="rejectTable" @dataLoaded="dataLoaded"
     :singleSelect="true"         :defaultParams="defaultParams" :showHeader="false" :defaultParamsAutoLoad="true" :autoLoad="true"></mw-table>
  </mw-dialog>
</template>
<script>

export default {
  props: {
    params: {
      type: Object
    }
  },
  data() {
    let me=this;
    return {
      title:$lang('选择退回节点'),

      api:'process.getCanRejectTo',
      defaultParams:{},
      columns: [
        {prop: 'name',tooltip:true, label: $lang('可发至任务'),formatter:me.formatter}
      ],
      footerButton: [
        {
          label: $lang("关闭"),
          type: "default",
          func:me.close
        },
        {
          label: $lang("确定"),
          func:me.submit
        }
      ]
    }
  },
  mounted() {
    setTimeout(()=>{
      this.show();
    },200)
    this.init();
  },
  watch: {
    params(){
      this.init();
    }
  },
  methods: {
    setBtnLoading(loading,idx){
      this.footerButton[idx].loading=loading;
    },
    dataLoaded(data){
      var me = this;
      //如果只有一条，默认选中
      if(data && data.length==1){
        let rejectTable = me.$refs.rejectTable;
        rejectTable.$refs.multipleTable.setCurrentRow(data[0]);
        if(rejectTable.multipleSelection.length===0){
          rejectTable.multipleSelection.push(data[0]);
        }
      }
    },
    btnDebounce:_.debounce(function(callback){
      let me=this;
      if(callback){
        callback();
      }
    }, 1000, {
      'leading': true,
      'trailing': false
    }),
    formatter(data){
      let isEnglish=window.$currentBrowserLanguage==='en';
      let englishName=data.Englishname || data.assigneeName;
      return <span>{$lang(data.name)}--{isEnglish? englishName : data.assigneeName} </span>
    },
    submit(){
      let me=this;
      me.btnDebounce(function(){
        me.setBtnLoading(true,1);
        let selected=me.mwRef('rejectTable').getMultipleSelection();
        if(selected.length==0){
          me.setBtnLoading(false,1);
          me.mwMsg('info',$lang('请选择退回的节点'));
          return;
        }
        let params={};
        params.type="reject";
        params.taskId=me.params.taskId;
        params.appId=me.params.appId;
        params.formId=me.params.formId;params.formKey=me.params.formKey;
        if(me.params.comment){
          params['$comment']=me.params.comment;
        }
        params.targetTaskId=selected[0].id;
        function doReject(params){
          if(me.params.fullAuthType){
            params.fullAuthType = me.params.fullAuthType;
          }
          me.mwApi.process.reject(params).then((res)=>{
            var data = res.result;
            if(data && !data.success){ //提交意见检查
              if(data.errorType=='comment'){
                if(data.errorCode=='comment_check_stop'){
                  me.mwMsg('info', $lang('您还没有填写意见,请填写意见!'));
                  me.setBtnLoading(false,1);
                  return;
                }else if(data.errorCode=='comment_check_remind'){
                  me.mwConfirm($lang('您还没有填写意见,您确认是要继续退回？'), $lang('提示'), {type: 'warning'}).then(()=>{
                    params['$directSave']=true;
                    doReject(params);
                  }).catch(()=>{
                    me.setBtnLoading(false,1);
                  });
                  return;
                }
              }else{
                var errorMsg = '';
                if(data.errorMsg){
                  errorMsg ='[' + $lang('错误信息') + ':'+data.errorMsg+']';
                }
                me.mwMsg('info', $lang('退回失败') + errorMsg+'!');
                me.setBtnLoading(false,1);
                return;
              }
            }else{
              if(me.params.formObj){
                if(me.params.formObj.fireEvent("afterReject",me)===false)
                  return;
              }
              me.close();
              me.formActionComplete();
              me.setBtnLoading(false,1);
            }
          }).catch(()=>{
            me.setBtnLoading(false,1);
          });
        }
        doReject(params);
      });
    },
    init(){
      this.defaultParams={taskId:this.params.taskId};
    },
    beforeClose(done){
      var me=this;
      //me.mwConfirm('确认退出退回？').then(_ => {
        if(me.params.secondfunc){
          me.params.secondfunc()
        }
        me.resetForm();
        done();
      // }).catch(_ => {
      // });
    },
    resetForm(){
      var me=this;

    },

    formActionComplete(){
      let me=this;
      if(me.params.func){
        me.params.func()
      }
      this.resetForm();
    },

    show(){
      this.mwRef('dialog').show();
    },
    close(){
      this.resetForm();
      this.mwRef('dialog').hide();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/public-dialog/reject.vue